export class SubscriberAgreementModel {
    idUser?: string = "";
    emailUser?: string = "";
    nameUser?: string = "";
    dateAccept?: Date|string = undefined;
    link: string = "";

    constructor(s?: Partial<SubscriberAgreementModel>) {
        Object.assign(this, s)
    }

    hasBeenAccepted():boolean {
        return !!this.idUser;
    }
}
